module.exports = __webpack_public_path__ + "static/img/game_success.a66f89e2.png";